var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.799,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.9411,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0122,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0832,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1543,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.492,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4214,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.434,
    x2: 340.825,
    y2: -90.3503,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.505,
    x2: 347.897,
    y2: -83.2793,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2082,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.1371,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0661,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7107,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5686,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49751,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57353,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.428,
    x2: 439.82,
    y2: 8.64464,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.5,
    x2: 446.892,
    y2: 15.7157,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 44,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.1421,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2842,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3553,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4974,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.658 112.389C112.884 112.389 111.228 112.097 109.692 111.513C108.177 110.907 106.847 110.063 105.7 108.981C104.553 107.9 103.655 106.634 103.006 105.184C102.378 103.713 102.065 102.122 102.065 100.413C102.065 98.6817 102.378 97.0913 103.006 95.6416C103.655 94.1918 104.542 92.9368 105.667 91.8766C106.814 90.8163 108.145 89.994 109.66 89.4098C111.174 88.8039 112.819 88.501 114.593 88.501C116.389 88.501 118.034 88.7823 119.527 89.3449C121.02 89.9075 122.318 90.6865 123.421 91.6818L119.105 96.0311C118.585 95.4685 117.947 95.0249 117.19 94.7003C116.454 94.3758 115.589 94.2135 114.593 94.2135C113.728 94.2135 112.927 94.3541 112.191 94.6354C111.477 94.9167 110.861 95.3278 110.341 95.8688C109.822 96.4097 109.411 97.0697 109.108 97.8487C108.827 98.606 108.686 99.4607 108.686 100.413C108.686 101.386 108.827 102.263 109.108 103.042C109.411 103.799 109.822 104.448 110.341 104.989C110.861 105.53 111.477 105.952 112.191 106.255C112.927 106.536 113.728 106.677 114.593 106.677C115.567 106.677 116.432 106.526 117.19 106.223C117.969 105.92 118.639 105.476 119.202 104.892L123.551 109.241C122.405 110.236 121.117 111.015 119.689 111.578C118.261 112.119 116.584 112.389 114.658 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.804 112.389C134.77 112.389 132.996 111.978 131.481 111.156C129.966 110.312 128.787 109.155 127.943 107.683C127.099 106.212 126.677 104.524 126.677 102.62V88.8905H133.169V103.204C133.169 103.94 133.331 104.567 133.656 105.087C133.98 105.606 134.413 106.006 134.954 106.288C135.517 106.547 136.133 106.677 136.804 106.677C137.496 106.677 138.102 106.547 138.622 106.288C139.163 106.006 139.584 105.617 139.887 105.119C140.19 104.6 140.342 103.972 140.342 103.237V88.8905H146.866V102.652C146.866 104.556 146.444 106.244 145.6 107.716C144.778 109.165 143.609 110.312 142.094 111.156C140.601 111.978 138.838 112.389 136.804 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.779 112.389C156.81 112.389 155.09 112.108 153.619 111.546C152.169 110.961 150.827 110.042 149.594 108.787L153.651 104.73C154.495 105.53 155.382 106.147 156.312 106.58C157.243 106.991 158.238 107.196 159.299 107.196C160.186 107.196 160.856 107.066 161.311 106.807C161.765 106.526 161.993 106.147 161.993 105.671C161.993 105.195 161.798 104.805 161.408 104.502C161.019 104.178 160.499 103.897 159.85 103.658C159.223 103.399 158.52 103.139 157.741 102.88C156.983 102.62 156.226 102.306 155.469 101.938C154.711 101.57 154.008 101.127 153.359 100.608C152.731 100.067 152.223 99.4066 151.833 98.6276C151.444 97.827 151.249 96.8533 151.249 95.7065C151.249 94.2135 151.606 92.926 152.32 91.8441C153.034 90.7622 154.04 89.9399 155.339 89.3774C156.637 88.7931 158.163 88.501 159.915 88.501C161.646 88.501 163.248 88.7823 164.719 89.3449C166.212 89.8858 167.445 90.6648 168.419 91.6818L164.329 95.739C163.615 95.0465 162.901 94.538 162.187 94.2135C161.473 93.8673 160.694 93.6942 159.85 93.6942C159.18 93.6942 158.639 93.8023 158.227 94.0187C157.838 94.2351 157.643 94.5597 157.643 94.9924C157.643 95.4468 157.838 95.8255 158.227 96.1284C158.617 96.4097 159.125 96.6694 159.753 96.9074C160.402 97.1454 161.105 97.3943 161.863 97.6539C162.642 97.9136 163.41 98.2273 164.167 98.5952C164.924 98.9414 165.617 99.3958 166.244 99.9584C166.894 100.499 167.413 101.181 167.802 102.003C168.192 102.825 168.387 103.821 168.387 104.989C168.387 107.348 167.543 109.176 165.855 110.474C164.189 111.751 161.83 112.389 158.779 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.18 112V88.8905H183.671V112H177.18ZM170.266 94.4082V88.8905H190.617V94.4082H170.266Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.861 112.454C203.043 112.454 201.366 112.151 199.83 111.546C198.316 110.94 196.985 110.096 195.838 109.014C194.713 107.932 193.836 106.655 193.209 105.184C192.581 103.713 192.268 102.122 192.268 100.413C192.268 98.6817 192.571 97.0913 193.176 95.6416C193.804 94.1918 194.68 92.926 195.805 91.8441C196.931 90.7622 198.251 89.9291 199.765 89.3449C201.302 88.739 202.979 88.4361 204.796 88.4361C206.614 88.4361 208.28 88.739 209.795 89.3449C211.331 89.9291 212.662 90.7622 213.787 91.8441C214.912 92.926 215.777 94.2026 216.383 95.674C217.011 97.1238 217.325 98.7142 217.325 100.445C217.325 102.155 217.011 103.745 216.383 105.216C215.777 106.666 214.912 107.943 213.787 109.046C212.662 110.128 211.342 110.972 209.827 111.578C208.312 112.162 206.657 112.454 204.861 112.454ZM204.796 106.742C206.008 106.742 207.057 106.482 207.944 105.963C208.832 105.444 209.513 104.708 209.989 103.756C210.465 102.804 210.703 101.689 210.703 100.413C210.703 99.4607 210.563 98.606 210.281 97.8487C210.022 97.0697 209.632 96.4097 209.113 95.8688C208.594 95.3062 207.966 94.8842 207.23 94.603C206.516 94.3 205.705 94.1486 204.796 94.1486C203.584 94.1486 202.535 94.4082 201.648 94.9275C200.761 95.4252 200.079 96.1501 199.603 97.1022C199.127 98.0326 198.889 99.1361 198.889 100.413C198.889 101.386 199.019 102.263 199.278 103.042C199.56 103.821 199.96 104.492 200.479 105.054C200.999 105.595 201.615 106.017 202.329 106.32C203.065 106.601 203.887 106.742 204.796 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 112V88.8905H226.002L234.603 101.484H232.559L241.127 88.8905H245.834V112H239.407V99.5364L240.348 99.7961L235.642 106.547H231.488L226.814 99.7961L227.723 99.5364V112H221.296Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.434 112L270.459 88.8905H275.522L271.465 112H266.434ZM257.054 105.736V101.516H276.334V105.736H257.054ZM258.807 112L262.864 88.8905H267.863L263.87 112H258.807ZM258.223 98.8873V94.7003H277.47V98.8873H258.223Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.281 108.527L289.499 99.2443C289.867 98.8765 290.159 98.5411 290.375 98.2382C290.613 97.9136 290.776 97.6106 290.862 97.3294C290.97 97.0481 291.025 96.7559 291.025 96.453C291.025 95.6957 290.776 95.1006 290.278 94.6679C289.802 94.2135 289.153 93.9863 288.331 93.9863C287.595 93.9863 286.913 94.2135 286.286 94.6679C285.658 95.1006 284.988 95.8471 284.274 96.9074L280.054 93.1099C281.006 91.5953 282.229 90.4484 283.722 89.6695C285.236 88.8905 286.957 88.501 288.882 88.501C290.635 88.501 292.139 88.8148 293.394 89.4423C294.671 90.0481 295.644 90.9245 296.315 92.0713C297.008 93.2181 297.354 94.5813 297.354 96.1609C297.354 97.0481 297.235 97.8811 296.997 98.6601C296.759 99.4391 296.38 100.207 295.861 100.965C295.341 101.7 294.671 102.458 293.848 103.237L288.039 108.754L280.281 108.527ZM280.281 112V108.527L285.669 106.677H297.841V112H280.281Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock2);
export default __webpack_public_path__ + "static/media/custom-block-2.8bfbe64ce18bf112183d6e6795a0df71.svg";
export { ForwardRef as ReactComponent };